


















































import Vue from "vue";
import { ScrappedReasonServiceProxy } from "@/service-proxies/app-v2/qc.service-proxies";
import AddorEditReason from "./AddOrEditReason.vue";
const scrappedReasonServiceProxy = new ScrappedReasonServiceProxy();
export default Vue.extend({
  name: "ScrapReason",
  components: {
    AddorEditReason,
  },
  data() {
    return {
      tableData: [],
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      editForm: {},
      addType: false,
      modalVisible: false,
      columns: [
        {
          title: this.$t("page_authority_action"),
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 198,
        },
        {
          title: this.$t("page_scrap_reason_code"),
          dataIndex: "code",
          key: "code",
          width: 200,
        },
        {
          title: this.$t("page_scrap_reason"),
          dataIndex: "reason",
          key: "reason",
          width: 120,
        },
        {
          title: this.$t("remark"),
          dataIndex: "remark",
          key: "remark",
          width: 120,
        },
      ],
      selectedRowKeys: [],
      visiable: false,
    };
  },
  props: {
    currentType: {
      type: Object,
      default: {}
    },
  },
  watch: {
    currentType(val) {
      if (val.id) {
        this.loadTableData()
      } else {
        this.tableData = []
      }
    }
  },
  created() {
    this.loadTableData();
    this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage
      this.loadTableData()
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys }: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: []) => {
          this.selectedRowKeys = selectedRowKeys;
          console.log(122, this.selectedRowKeys)
        },
      };
    },
  },

  methods: {
    loadTableData() {
      if (!this.currentType.id) {
        return
      }
      scrappedReasonServiceProxy
        .qcGetPageScrappedReason(
          this.pagination.current,
          this.pagination.pageSize,
          this.currentType.id
        )
        .then((res) => {
          console.log(111, res);
          this.pagination.total = res.total
          this.tableData = res.records || [];
        });
    },
    groupDelete(ids) {
      scrappedReasonServiceProxy.qcDeleteScrappedReason(ids).then(res => {
        this.$message.info(this.$t('delete_success'))
        this.loadTableData()
      }) 
    },
    openEditModal(record) {
      this.editForm = record
      console.log('recode', record)
      this.modalVisible = true
      this.addType = false
    },
    handleCancel(flag) {
      this.modalVisible = false
      if (flag) {
        this.loadTableData()
      }
    }
  },
});
